import { EMPTY_OBJ } from '@lacele/const'
import { errorSerializer, makeQueryString } from '@lacele/utils'
import actionTarget from '../Redux/actionTarget'
import fetchErrorSerializer from './errorSerializer'
import { sessionInvalidate } from '../../commons/SessionReducer/action'
// import { messageAdd } from '../Error/action'
// import { getPopupsTarget } from '../MainContainer/utils'
// import { STORE_TARGET_MAIN_CONTEXT } from '../MainContainer/const'
// import { stackContainerAdd } from '../StackContainer/actions'
// import { sessionInvalidate } from '../SessionHolder/actions'
// import { getMessagesTarget } from '../SessionHolder/utils'
// import { STORE_TARGET_SESSION_CONTEXT } from '../SessionHolder/const'
import {
    fetchPending,
    fetchedData,
    fetchedError,
    fetchedUnauthorized
} from './FetchComponent/actions'
// import { sessionInvalidate } from '../SessionReducer/action'
import fetchJSONBase, { fetchCheckStatus } from './fetchJSON'
import {
    INTERNAL_API_PREFIX,
    HEADERS_TO_SERIALIZE,
    HEADER_X_WWW_AUTHENTICATE,
    STATUS_UNAUTHORIZED,
    // ERROR_ITEM_FETCHED
} from './const'

errorSerializer.override(fetchErrorSerializer)

export class FetchService {

    fetch(context) {
        const newContext = context || EMPTY_OBJ
        this.dispatchAction(newContext, fetchPending())
        const options = this.makeOptions(newContext)
        return fetchCheckStatus(this.getUrlWithQueryString(newContext), options)
            .catch(this.onErrorHandlerRethrow.bind(this, newContext))
    }

    fetchJSON(context) {
        const newContext = context || EMPTY_OBJ
        this.dispatchAction(newContext, fetchPending())
        const options = this.makeOptions(newContext)
        const url = this.getUrlWithQueryString(newContext)
        return fetchJSONBase(url, options)
            .then(this.onSuccessHandler.bind(this, newContext))
            .catch(this.onErrorHandlerRethrow.bind(this, newContext))
    }

    getUrlWithQueryString(context) {
        return context.query
            ? (context.url + makeQueryString(context.query))
            : context.url
    }

    dispatchAction(context, action) {
        const newContext = context || EMPTY_OBJ
        if (newContext.dispatch && newContext.storeTarget) {
            newContext.dispatch(actionTarget(action, newContext.storeTarget))
        }
    }

    dispatchErrorMessage(context, error, response) {
        console.log('fetchService.dispatchErrorMessage', context, error, response)
        /*
        TODO
        */
        const newContext = context || EMPTY_OBJ
        return Promise.resolve(errorSerializer.serialize(newContext, error))
            .then((errorData) => {
                this.dispatchAction(newContext, fetchedError(errorData, response))
                /*
                if (!this.isUnauthorizedError(error)) {
                    // TODO temporary solution: dispatch the error to the portal session.
                    // In the future we should handle fetch errors inside each component,
                    // for example a yellow triangle icon will signal the user of non fresh data.
                    const errorItemId = errorData.errorItemId || ERROR_ITEM_FETCHED
                    if (newContext.dispatch) {
                        newContext.dispatch(actionTarget(messageAdd({
                            [errorItemId]: errorData
                        }), getMessagesTarget(context[STORE_TARGET_SESSION_CONTEXT])))
                    }
                }
                */
            })
    }

    makeOptions(context) {
        const newContext = context || EMPTY_OBJ
        let options = newContext.options || EMPTY_OBJ
        options = {
            ...options,
            headers: {
                ...options.headers || EMPTY_OBJ,
                'Access-Control-Allow-Origin': '*'
            }
        }
        if (!newContext.disableContentType) {
            options = {
                ...options,
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers || EMPTY_OBJ
                }
            }
        }
        if (!options.credentials) {
            // YAM-447
            // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Sending_a_request_with_credentials_included
            // This is to avoid the browser basic authentication popup
            options = {
                ...options,
                // credentials: 'omit'
                credentials: 'same-origin',
            }
        }
        if (newContext.authorization) {
            options = {
                ...options,
                headers: {
                    ...options.headers,
                    Authorization: newContext.authorization
                }
            }
        }
        if (newContext.method) {
            options = {
                ...options,
                method: newContext.method
            }
        }
        if (newContext.body) {
            options = {
                ...options,
                body: newContext.body
            }
        }
        if (newContext.absoluteUrl) {
            options = {
                ...options,
                absoluteUrl: newContext.absoluteUrl
            }
        }
        if (newContext.xAuthToken && !options.absoluteUrl) {
            options = {
                ...options,
                headers: {
                    ...options.headers,
                    'x-auth-token': newContext.xAuthToken
                }
            }
        }
        if (newContext.includeResponse) {
            options = {
                ...options,
                includeResponse: newContext.includeResponse
            }
        }
        if (newContext.responseType) {
            options = {
                ...options,
                responseType: newContext.responseType
            }
        }
        if (newContext.credentials) {
            options = {
                ...options,
                credentials: newContext.credentials
            }
        }
        return options
    }

    isUnauthorizedError(error) {
        return error.response && error.response.status === 401
    }

    isUnauthorizedInternalApiErrorDefault(context, error) {
        return (
            this.isUnauthorizedError(error)
            && context.url.startsWith(INTERNAL_API_PREFIX)
        )
            || (
                error.response && error.response.status === 400
                && error.response.headers
                && error.response.headers.get(HEADER_X_WWW_AUTHENTICATE)
            )
    }

    isUnauthorizedInternalApiError(context, error) {
        const {
            unauthorizedInternalApiErrorFilter
        } = context
        let result = this.isUnauthorizedInternalApiErrorDefault(context, error)
        if (unauthorizedInternalApiErrorFilter) {
            result = unauthorizedInternalApiErrorFilter(context, error, result)
        }
        return result
    }

    onSuccessHandler(context, data) {
        const newContext = context || EMPTY_OBJ
        // Update redux store with results
        let result = data
        if (newContext.dispatch) {
            let dispatchedResponse = null
            let dispatchedData
            if (newContext.includeResponse) {
                dispatchedResponse = this.serializeResponse(data.response)
                if (data.hasOwnProperty('json')) {
                    dispatchedData = data.json
                    result = dispatchedData
                } else if (data.hasOwnProperty('text')) {
                    dispatchedData = data.text
                    result = dispatchedData
                } else if (data.hasOwnProperty('blob')) {
                    dispatchedData = null
                    result = data.blob
                }
            }
            if (dispatchedData === undefined) {
                dispatchedData = { ...data }
                delete dispatchedData.response
            }
            this.dispatchAction(newContext, fetchedData(dispatchedData, dispatchedResponse))
        }
        return result
    }

    onErrorHandler(context, error) {
        console.log('fetchService.onErrorHandler', context, error)

        // TODO LOGOUT?
        // show login...

        const newContext = context || EMPTY_OBJ
        if (newContext.dispatch && this.isUnauthorizedInternalApiError(newContext, error)) {
            newContext.dispatch(sessionInvalidate())
            console.log('fetchService.onErrorHandler dispatchAction unauth')
            this.dispatchAction(newContext, fetchedUnauthorized())
            /*
            newContext.dispatch(actionTarget(stackContainerAdd({
                type: 'LoginPopup'
            }), getPopupsTarget(context[STORE_TARGET_MAIN_CONTEXT])))
            */
            return Promise.resolve(STATUS_UNAUTHORIZED)
        }
        let response = null
        if (newContext.includeResponse) {
            response = this.serializeResponse(error.response)
        }
        if (newContext.onErrorHandler) {
            return Promise.resolve(newContext.onErrorHandler(error, response))
                .catch(
                    (promiseError) => this.dispatchErrorMessage(newContext, promiseError, response)
                )
        }
        return this.dispatchErrorMessage(newContext, error, response)
    }

    onErrorHandlerRethrow(context, err) {
        console.log('fetchService.onErrorHandlerRethrow', context, err)
        /*
        TODO
        const newContext = context || EMPTY_OBJ
        this.onErrorHandler(newContext, err)
        throw err
        */
    }

    serializeResponse(response) {
        if (!response) {
            return null
        }
        const headers = {}
        if (response.headers) {
            for (const key of HEADERS_TO_SERIALIZE) {
                if (response.headers.get(key)) {
                    headers[key] = response.headers.get(key)
                }
            }
        }
        return {
            status: response.status,
            headers
        }
    }
}

export default new FetchService()
